import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Input, Spinner } from '@nextui-org/react'
import { GET } from '../../../utils/requests';
import Paginations from '../../../components/Pagination';
import { belen_uri, orders_uri } from '../../../utils/url';
import axios from 'axios';
import { Spin } from 'antd';
import { toast } from 'react-toastify';
import OrderDetailModal from './Modals/orderDetail';
import OrderReject from './Modals/orderReject';

const BelenBaraaOrders = () => {
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({limit:15, all:'', totalPage:'',title:''});
  const [page, setPage] = useState(1);

  useEffect(() => {
    Get();
  }, [page]);

  const Get = async () => {
    setLoad(true);
    const b = await GET(belen_uri+`/orders?page=${page}&status=REQUESTED&limit=${pagination.limit}&title=${pagination.title}`);
    setData(b.data.data);
    setPagination({...pagination, all:b.data.all, totalPage:b.data.totalPage});
    setLoad(false);
  };

  const deleteHandle = async(id)=>{
    setLoad(true);
    try{
      const res = await axios.get(belen_uri+`/delete?id=${id}`);
      if(res.status === 200){
        toast.success("Амжилттай");
        Get();
      }
      setLoad(false);
    }catch(err){
      setLoad(false);
      console.log(err);
    }
  }

  const callback =()=> {
    Get();
  }
  
  const changePage = (page) => {
    setPage(page);
  };

  return (
    <div>
      <div>

      <div className="flex flex-col mr-2 mt-2 font-Roboto">
          <div className="overflow-x-auto shadow-md sm:rounded-md">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden ">
              <div className='bg-white p-4'>
                <div className='flex items-center justify-between mb-2'>
                  <h1 className='text-lg font-bold'>Бэлэн барааны мэдээлэл</h1>
                </div>
                <div className='flex items-center gap-2'>
                  <input size='' className='border rounded-lg mt-2 focus:border-1 focus:border-blue-600 outline-none w-full p-2 bg-gray-100' placeholder='Хайлт хийх' onChange={(e) => setPagination({...pagination, title:e.target.value})}/>
                  {
                    load?
                    <Button className='mt-1 bg-gray-200'><Spinner/></Button>
                    :
                    <Button onClick={Get} className='mt-1 bg-gray-200'>Хайх</Button>
                  }
                </div>
              </div>
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="p-4 text-sm font-normal">
                        No
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Захиалсан хэрэглэгч
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Нэмэлт утасны дугаар
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       Дэлгэрэнгүй
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       Барааны тоо
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       Үүсгэсэн огноо
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400"></th>
                    </tr>
                  </thead>
                  {
                    load?
                    <div className='flex items-center justify-center  p-4'>
                      <Spinner/>
                      <h1 className=''>Уншиж байна ...</h1>
                    </div>
                    :
                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {
                        data.map((item, index) => {
                          return(
                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                              <td className="p-2 w-4 text-center">
                                {index+1}
                              </td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                <label className='text-lg'>{item.user.phone_no}</label>
                                <label className='mt-1'>{item.user.deposit}</label>
                              </td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.phone}</td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                {item.explanation}
                              </td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                {item.userToCartItem.length}
                              </td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                {item.createdAt}
                              </td>
                              <td className="py-2 px-6 text-sm font-medium flex items-center gap-1 text-gray-500  dark:text-white text-overflow">
                                <OrderDetailModal callback={callback} data={item}/>
                                <OrderReject callback={callback} data={item}/>
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
                {
                  data.length === 0 &&
                  <div className='bg-white pt-8 text-center flex items-center justify-center flex-col'>
                    <img className='h-24' src='../../empty.gif'/>
                    <h1 className=''>Хоосон байна...</h1>
                  </div>
                }
               <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default BelenBaraaOrders


